import { z } from 'zod';

/** Must stay in step with `PreflightBrand.name` and `PreflightReport.brandName` widths. */
export const PREFLIGHT_BRAND_NAME_MAX_LENGTH = 255;

/**
 * A brand's identity within a tenant: trimmed and lowercased, so "Acme" and "acme "
 * are one brand. The repo's unique key and the create-report membership check both
 * compare this key, so they cannot drift apart.
 */
export function toPreflightBrandKey(name: string): string {
    return name.trim().toLowerCase();
}

export const PreflightBrandNameSchema = z
    .string()
    .trim()
    .min(1, 'Brand name is required')
    .max(PREFLIGHT_BRAND_NAME_MAX_LENGTH);

export const CreatePreflightBrandBodySchema = z.object({
    name: PreflightBrandNameSchema,
});
export type CreatePreflightBrandBody = z.infer<typeof CreatePreflightBrandBodySchema>;

/** Renaming changes the list only; reports keep the brand name they were scored for. */
export const UpdatePreflightBrandBodySchema = CreatePreflightBrandBodySchema;
export type UpdatePreflightBrandBody = z.infer<typeof UpdatePreflightBrandBodySchema>;

export const PreflightBrandSchema = z.object({
    id: z.string(),
    name: z.string(),
});
export type PreflightBrand = z.infer<typeof PreflightBrandSchema>;
